/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class GisDataStoreMetadataMappingService extends
    services.DataService<Wars.Domain.Model.Gis.GisDatastoreMetadataMapping> {
        constructor(
            injectedBreeze: typeof breeze,
            $q: angular.IQService,
            private $http: angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createGisDatastoreMetadataMapping(): Wars.Domain.Model.Gis.GisDatastoreMetadataMapping {
            return <Wars.Domain.Model.Gis.GisDatastoreMetadataMapping>this.createNewEntity(
                "GisDatastoreMetadataMapping");
        }

        public getGisDatastoreMetadataMappings(processConfigurationId: string): angular.
            IPromise<Wars.Domain.Model.Gis.GisDatastoreMetadataMapping[]> {
            let query = this.breezeModule.EntityQuery.from("GisDatastoreMetadataMappings");

            var expand = "gisDatastore,gisDatastorePropertyMapping1,gisDatastorePropertyMapping2," +
                "gisDatastorePropertyMapping3,gisDatastorePropertyMapping4,gisDatastorePropertyMapping5," +
                "gisDatastorePropertyMapping6,gisDatastorePropertyMapping7,gisDatastorePropertyMapping8," +
                "gisDatastorePropertyMapping9,gisDatastorePropertyMapping10";

            query = query.where('processConfiguration_id', '==', processConfigurationId)
                .expand(expand);

            return this.executeQuery(query);
        }

    }
}

warsApp.registerService('GisDataStoreMetadataMappingService', ['breeze', '$q', '$http']);